import t from "../../../i18n/i18n";

function Social() {
  return (
    <div className="header-social">
      <ul>
        <li>
          <a href={t("Config.Facebook")}>
            <img src="/images/facebook-icon.png" alt="" />
          </a>
        </li>
        <li>
          <a href={t("Config.Instagram")}>
            <img src="/images/instagram.png" alt="" />
          </a>
        </li>
        <li>
          <a href={t("Config.Youtube")}>
            <img src="/images/youtube_icon.png" alt="" />
          </a>
        </li>
        <li>
          <a href={t("Config.Discord")}>
            <img src="/images/discord_icon.png" alt="" />
          </a>
        </li>
      </ul>
    </div>
  );
}

export default Social;
